// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de la ruleta dentro del juego
 * @param {*} scene 
 */
export function cargaAssetsRuleta(scene) {
  scene.load.image(
    "ruletaEstatica",
    ROUTES.rutaRuletaRuleta + "/ruleta1EstaticaResized.png"
  );

  scene.load.spritesheet(
    "ruletaGirando",
    ROUTES.rutaRuletaRuleta + "/ruleta1GirandoResized-Sheet.png",
    {
      frameWidth: 228,
      frameHeight: 228,
    }
  );
}
